import axios from "axios";
import { useEffect, useState } from "react";
import { useStore } from "../context/StoreContext";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const LOGO =
  "/logo.webp";

export const slugify = (s) =>
  s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const money = (n) => `$${Number(n).toFixed(2)}`;

export function useApi(path, params = {}) {
  const { preview } = useStore();
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const key = JSON.stringify(params);
  useEffect(() => {
    if (!path) return undefined;
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    http
      .get(path, { params: { ...JSON.parse(key), include_drafts: preview } })
      .then((r) => alive && setState({ data: r.data, loading: false, error: null }))
      .catch((e) => alive && setState({ data: null, loading: false, error: e }));
    return () => {
      alive = false;
    };
  }, [path, key, preview]);
  return state;
}
